import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import { NETWORK_THREAT_PATH } from "@js2/path";
import { getRoute } from "@modules/network/components/common/NetworkLink";
import { useNetworkRoute } from "@modules/network/hooks/useNetworkRoute";

const Infrastructure = () => {
  const [name = "", value = ""] = useNetworkRoute();
  const link = getRoute(NETWORK_THREAT_PATH.INFRASTRUCTURE, name, value);
  return (
    <Nav.Item>
      <Nav.Link
        as={Link}
        to={link}
        key="infrastructure"
        eventKey="infrastructure"
        data-testid="infrastructure-nav-item"
      >
        Infrastructure
      </Nav.Link>
    </Nav.Item>
  );
};

export default Infrastructure;
